import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DropDownSection = (props) => {
  const label = (
    <label className="dropdown-section-label" htmlFor="requestSignatureOptions">
      {props.label}
    </label>
  );
  const options = props.options.map(option => (
    <option key={option.label + option.value} value={option.value}>{ option.label }</option>
  ));
  let postLabel = '';
  if (props.postLabel) {
    const postLabelClassNames = classNames(
      'dropdown-section-post-label',
      {
        'dropdown-section-post-label-highlighted': props.highlightDropDownSection,
        'lighter-text': !props.highlightDropDownSection,
      },
    );
    const postLabelTextClassNames = classNames(
      { 'dropdown-section-text': props.highlightDropDownSection },
    );
    postLabel = (
      <label className={postLabelClassNames} htmlFor="requestSignatureOptions">
        {props.postLabel.split('\n').map(
          labelLine => (
            <div className={postLabelTextClassNames}>
              {labelLine}
            </div>
          ),
        )}
      </label>
    );
  }
  const dropDownSectionPostLabelWrapperClasses = classNames(
    { 'dropdown-section-post-label-wrapper-highlighted': props.highlightDropDownSection },
  );

  return (
    <div className="static-request-signature-content-section">
      {props.showDropDown &&
        <div>
          {label}
          <select id="requestSignatureOptions" onChange={props.onChange}>
            {options}
          </select>
        </div>
      }
      <div className={dropDownSectionPostLabelWrapperClasses}>
        {postLabel}
      </div>
    </div>
  );
};

DropDownSection.propTypes = {
  highlightDropDownSection: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  postLabel: PropTypes.string,
  showDropDown: PropTypes.bool,
};

DropDownSection.defaultProps = {
  highlightDropDownSection: false,
  onChange: () => (false),
  postLabel: '',
  showDropDown: true,
};

export default DropDownSection;



// WEBPACK FOOTER //
// ./src-react/StaticRequestSignatureContentSection/components/DropDownSection.jsx